import SharedCameraStatusTile from 'camera-module/camera/ui/camera-status-page/SharedCameraStatusTile'
import Share from 'assets/icons/status/Share'

const SharedCameraTile = ({ value, isShared }) => {
  return <SharedCameraStatusTile label="app:camera.number_guests" isShared={isShared} icon={<Share />} value={value} useSVGIcon />
}

export default SharedCameraTile
